<div class="ps-3 pe-2">
    <h4 class="mb-2 text-dpblue300">
        <fa-icon [icon]="icon" class="me-2 fa-1x" size="1x"></fa-icon>
        {{ title | translate }}
    </h4>

    <div style="white-space: pre-wrap; font-family: 'Courier New', Courier, monospace;">{{ logContent }}</div>
    @if (logEmptyMessage) {
        <span style="margin-left: 20px;"> {{ (logEmptyMessage | translate)}} </span>
    }
</div>
